module.exports = __webpack_public_path__ + "static/media/adrian-dworanowski.5e54aa82.jpg";